import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { GroupElement } from '../../../models';
import { GroupPermissions } from '../../../constants/group.constant';
import {
  handleCancelJoinGroup,
  handleJoinGroup,
} from '../../../components/group-items/group-item';
import { groupService } from '../../../services/group.service';
import { fetchUrlImages } from '../../../api/posts/fetch-post.api';
import toast from 'react-hot-toast';
import { isPrivateGroup } from '../../../utils/group-privacy';

export const leaveGroup = async (groupId: string) => {
  const res = await groupService.leaveGroup(groupId);
  if (res.status === 200) {
    toast.success('rời nhóm thành công');
  }
};
const GroupBanner = ({
  data,
  permission,
  handleRefetch,
  loading,
  setActiveTab,
}: {
  data?: any;
  permission: any;
  handleRefetch: () => void;
  loading: boolean;
  setActiveTab?: (key: string) => void;
}) => {
  const isJoined = data?.joinedTheGroup ?? false;
  const [dropdownOpen, setDropdownOpen] = React.useState(false); // State để mở dropdown
  const coverInputRef = React.useRef<HTMLInputElement>(null);
  const [uploadingCover, setUploadingCover] = React.useState(false);

  // Đổi ảnh bìa nhóm: chọn ảnh → upload media → cập nhật groupCoverImageUrl.
  const handleChangeCover = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    try {
      setUploadingCover(true);
      const formData = new FormData();
      formData.append('type', file);
      const res = (await fetchUrlImages(formData)) as any[];
      const url = res?.find((r: any) => r?.url)?.url;
      if (!url) throw new Error('upload failed');
      const g = data?.group || data;
      await groupService.updateGroup({ ...g, groupCoverImageUrl: url }, g.id);
      toast.success('Đã đổi ảnh bìa nhóm');
      handleRefetch();
    } catch {
      toast.error('Đổi ảnh bìa thất bại, thử lại.');
    } finally {
      setUploadingCover(false);
    }
  };
  return (
    <div className="bg-white shadow  lg:-mt-10 dark:bg-dark2">
      <div className="relative overflow-hidden w-full lg:h-72 h-36">
        <img
          src={data?.groupCoverImageUrl}
          alt="cover"
          className="h-full w-full object-cover inset-0"
        />

        <div className="w-full bottom-0 absolute left-0 bg-gradient-to-t from-black/60 pt-10 z-10 pointer-events-none" />

        {permission === GroupPermissions.GROUP_ADMIN && (
          <div className="absolute bottom-0 right-0 m-4 z-20">
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap justify-end">
              <input
                hidden
                type="file"
                accept="image/*"
                ref={coverInputRef}
                onChange={handleChangeCover}
              />
              <button
                type="button"
                disabled={uploadingCover}
                onClick={() => coverInputRef.current?.click()}
                className="button bg-black/50 hover:bg-black/60 text-white flex items-center gap-2 backdrop-blur-small disabled:opacity-60"
              >
                {uploadingCover ? 'Đang tải…' : 'Đổi ảnh bìa'}
              </button>
              <button
                type="button"
                onClick={() => setActiveTab?.('thiet-lap')}
                className="button bg-black/50 hover:bg-black/60 text-white flex items-center gap-2 backdrop-blur-small"
              >
                Chỉnh sửa thông tin nhóm
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="lg:px-10 md:p-5 p-3">
        <div className="flex flex-col justify-center">
          <div className="flex lg:items-center justify-between max-md:flex-col">
            <div className="flex-1">
              <h3 className="md:text-2xl text-base font-bold text-black dark:text-white">
                {' '}
                {data?.groupName ?? data.group.groupName}{' '}
              </h3>
              <p className="font-normal text-gray-500 mt-2 flex gap-2 flex-wrap dark:text-white/80">
                <span className="max-lg:hidden uppercase">
                  {/* Theo groupType (máy chủ thực thi theo trường này), không theo chữ privacySettings. */}
                  {isPrivateGroup(data) ? 'Nhóm riêng tư' : 'Nhóm công khai'}
                </span>
              </p>
            </div>

            <div>
              {permission !== GroupPermissions.GROUP_ADMIN && (
                <div className="flex items-center gap-2 mt-1">
                  {!isJoined && (
                    <button
                      className={`button   dark:text-white gap-1 max-md:hidden ${
                        data?.userStatus === 'PENDING'
                          ? 'bg-red-200 text-red-500'
                          : 'bg-primary-soft text-primary'
                      }`}
                      onClick={() => {
                        if (!data?.userStatus) {
                          handleJoinGroup(data?.group.id);
                          setTimeout(() => handleRefetch(), 100); // Delay 0.3s
                        } else if (
                          data?.userStatus.toLocaleLowerCase() ===
                          'PENDING'.toLocaleLowerCase()
                        ) {
                          handleCancelJoinGroup(data?.group.id);
                          setTimeout(() => handleRefetch(), 100); // Delay 0.3s
                        }
                      }}
                    >
                      {loading ? (
                        'loading'
                      ) : (
                        <span className="text-sm">
                          {data?.joinedTheGroup
                            ? 'đã tham gia'
                            : data?.userStatus === 'PENDING'
                            ? ' Huỷ yêu cầu'
                            : 'tham gia'}
                        </span>
                      )}
                    </button>
                  )}
                  {isJoined && (
                    <div className="relative">
                      <button
                        type="button"
                        className="rounded-lg bg-slate-100 flex px-2.5 py-2 dark:bg-dark2"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        <BsThreeDots />
                      </button>
                      {dropdownOpen && (
                        <div className="absolute right-0 w-[240px] bg-white dark:bg-dark2 rounded-lg shadow-md mt-2">
                          <nav>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                              Nội dung của bạn
                            </a>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                              Chia sẻ
                            </a>

                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                            >
                              Báo cáo nhóm
                            </a>

                            <hr />
                            <a
                              href="#"
                              className="block px-4 py-2 text-red-400 hover:bg-red-50 dark:hover:bg-red-500/50"
                              onClick={() => leaveGroup(data?.group.id)}
                            >
                              Rời nhóm
                            </a>
                          </nav>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GroupBanner.propTypes = {};

export default GroupBanner;
